module.exports = __webpack_public_path__ + "img/25800.ec172c41.jpg";